// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"36338885","453":"37a6d2e5","938":"21d64c51"}[chunkId] + ".chunk.js";
};